import { render, staticRenderFns } from "./local-invoices-list.vue?vue&type=template&id=200a6f32&"
import script from "./local-invoices-list.vue?vue&type=script&lang=js&"
export * from "./local-invoices-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports